<template>
  <div>
    <LoadingAnimation full-page v-if="loadingAnimationFullPage"/>
    <template v-if="pdfPage">
      <StatisticProjectReportsBlankPDF
        :project="data.data.project"
        :date="dateInfo"
        :employees="data.data.employees"
        :confirmed="reports.confirmed"
        :notes="notes"
        :images="images"
        :images-count="images_count"
        :key="images_count.key + '_' + $route.fullPath"
      />
    </template>
    <template v-else>
      <StatisticProjectReportsBlankConfirmTable
        v-if="confirmPage"
        :project="data.data.project"
        :date="dateInfo"
        :employees="data.data.employees"
        :on-confirm-page="onConfirmPage"
        :confirm-page="confirmPage"
        :confirmed="reports.confirmed"
        :on-change-confirm="onChangeReportsConfirm"
        :on-change-notes="onChangeNotes"
        :notes="notes"
        :on-change-images="onChangeImages"
        :images="images"
        :on-change-images-count="onChangeImagesCount"
        :key="'confirmTable' + key + confirmPage"
      />
      <StatisticProjectReportsBlankExcelTable
        v-else
        :project="data.data.project"
        :date="dateInfo"
        :total-work-types="data.data.work_types"
        :total-extras="data.data.extras"
        :employees="data.data.employees"
        :on-update="onUpdate"
        :on-confirm-page="onConfirmPage"
        :key="'excelTable' + key + $route.fullPath"
      />
    </template>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
import StatisticProjectReportsBlankExcelTable from "./blank/excel/StatisticProjectReportsBlankExcelTable";
import LoadingAnimation from "../../LoadingAnimation";
import StatisticProjectReportsBlankConfirmTable from "./blank/confirm/StatisticProjectReportsBlankConfirmTable";
import StatisticProjectReportsBlankPDF from "components/timeControl/reports/blank/pdf/StatisticProjectReportsBlankPDF";

export default {
  name: 'StatisticProjectReportsBlank',
  components: {
    StatisticProjectReportsBlankPDF,
    StatisticProjectReportsBlankConfirmTable,
    LoadingAnimation,
    StatisticProjectReportsBlankExcelTable
  },
  props: {
    data: Object,
    weeks: String,
    onReportShow: {},
    onReportUpdate: {}
  },
  data: () => ({
    key: 0,
    loadingAnimationFullPage: false,
    confirmPage: false,
    reports: {
      confirmed: {
        work_types: [],
        extras: []
      },
      additional: []
    },
    notes: true,
    images: false,
    images_count: {
      key: 0,
      value: {
        0: 1,
      }
    },
    // units: ['t', 'm²', 'm³', 'kpl', 'jm', 'erä'],

  }),
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('user', ['userData']),

    pdfPage() {
      return (
        this.$route.name === 'timeControlShowReportsViewPdf'
        || this.$route.name === 'timeControlShowReportsViewFreePdf'
        || this.$route.name === 'linkProjectReportSign'
      )
    },
    dateInfo() {
      return this.$formatDate(this.data.start_date)
        + (this.data.end_date
          ? (' - ' + this.$formatDate(this.data.end_date))
          : '')
        + (this.weeks
          ? (' ' + this.localStorage.translations.pages.finance['period-table'].weeks + ' ' + this.weeks)
          : '')
    },
  },
  mounted() {
    this.prepareReportsData()
  },
  methods: {
    async onUpdate(data, switchValue, paid, extra) {
      if (!paid) this.onChangeReportsConfirm('work_types', data.map(i => i.id), switchValue)
      if (data && data.length > 0) {
        this.loadingAnimationFullPage = true
        if (this.onReportUpdate)
          await this.onReportUpdate({
            id: this.$route.params.report_id,
            data: data,
            paid: paid,
            extra: extra
          })
            .then(() => {
              this.updateReport()
            })
      }
    },

    async updateReport() {
      if (this.onReportShow)
        await this.onReportShow(this.$route.params.report_id).then(() => {
          this.loadingAnimationFullPage = false
          this.prepareReportsData()
          this.key++
        })
    },

    onConfirmPage(value) {
      this.confirmPage = value
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },

    prepareReportsData() {
      this.images = this?.data?.data?.project?.images_in_report || false
      let employees = Object.values(this.data.data.employees)
      for (let type in this.reports.confirmed) {
        this.reports.confirmed[type] = []
        for (let id in employees) {
          let days = Object.values(employees[id][type])
            .map(data => Object.values(data.days).map(day => day.reports))
          for (let day in days)
            for (let work in days[day])
              for (let r in days[day][work])
                if (days[day][work][r].approved_report > 0 && days[day][work][r]['client_bill_id'] === null)
                  this.reports.confirmed[type].push(days[day][work][r].id)
          for (let item in this.data.data.employees[id][type]) {
            let ddd = Object.keys(this.data.data.employees[id][type][item].days)
            for (let dd in ddd) {
              let d = ddd[dd]
              for (let r in this.data.data.employees[id][type][item].days[d].reports) {
                if (this.data.data.employees[id][type][item].days[d].reports[r].image) {
                  this.data.data.employees[id][type][item].days[d].reports[r].image = JSON.parse(this.data.data.employees[id][type][item].days[d].reports[r].image)
                }
              }
            }
          }
        }
      }
    },

    onChangeReportsConfirm(type, collection, switchValue, type2, collection2) {
      for (let i in collection) {
        let index = this.reports.confirmed[type].indexOf(collection[i])
        if (switchValue) {
          if (index === -1) this.reports.confirmed[type].push(collection[i])
        } else if (index > -1) this.reports.confirmed[type].splice(index, 1)
      }
      for (let i in collection2) {
        let index = this.reports.confirmed[type2].indexOf(collection2[i])
        if (switchValue) {
          if (index === -1) this.reports.confirmed[type2].push(collection2[i])
        } else if (index > -1) this.reports.confirmed[type2].splice(index, 1)
      }
      this.key++
    },

    onChangeNotes() {
      this.notes = !this.notes
    },

    onChangeImages() {
      this.images = !this.images
    },

    onChangeImagesCount(data) {
      for (let i in data) {
        this.images_count.value[i] = data[i]
      }
      this.images_count.key++
    }

  }
}
</script>

<style scoped lang="scss">
:deep() .fixedBtn {
  z-index: 10;
  position: fixed;
  bottom: 165px;
  right: 10px;
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 1fr;
  grid-gap: 4px;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    padding: 15px 12px;
    bottom: 135px;
    right: -2px;
  }

  .v-btn {
    background-color: #277FAF !important;
    color: #F2F2F2 !important;
    border-radius: 50px !important;

    &:hover {
      background-color: white !important;
      color: #277FAF !important;
      border: 1px solid #277FAF !important;
    }
  }
}
</style>
